import { combineReducers } from "redux";
import NotificationReducer from "./NotificationReducer";
import appSlice from "../slices/app/appSlice";
import serviceTicketSlice from "../slices/app/serviceTicketSlice";
import payementSlice from "../slices/app/paymentSlice";
import userDetailSlice from "../slices/app/userDetailsSlice";
import propertiesSlice from "../slices/app/propertiesSlice";
import messageListSlice from "../slices/app/messageSlice";
import billingSlice from "../slices/app/billingSlice";
import transactionHistorySlice from "../slices/app/transactionHistorySlice";
import useageSlice from "../slices/app/usageSlice";
import roleSettingSlice from "../slices/app/roleSettingsSlice";
import legacySlice from "../slices/app/legacySlice";
import registerSlice from "../slices/app/registerSlice";
import planAddonsSlice from "../slices/app/planAddonsSlice";
import communicationSlice from "../slices/app/communicationSlice";
import announcementSlice from "../slices/app/announcementSlice";
import chatBotSlice from "../slices/app/chatBotSlice";
import premiseSlice from "../slices/app/premiseSlice";
import documentSlice from "../slices/app/documentsSlice";
import manageFiberServiceSlice from "../slices/app/manageFiberServiceSlice";
import fiberEnrollmentIssueSlice from "../slices/app/fiberEnrollmentIssueSlice";
import connectionSlice from "../slices/app/connectionSlice";
import depositSlice from "../slices/app/depositsSlice";
import issueCreditSlice from "../slices/app/issueCreditSlice";
import enrollmentQueueSlice from "../slices/app/enrollmentQueueSlice";
import generateInvoiceSlice from "../slices/app/generateInvoiceSlice";
import signedCommunitiesSlice from "../slices/app/signedCommunities";
import dailySales from "../slices/app/dailySales";
import bulksmxsfupdateSlice from "../slices/app/bulksmxsfupdateSlice";
import addPaymentMethodSlice from "../slices/app/addPaymentMethodSlice";

const RootReducer = combineReducers({
  notifications: NotificationReducer,
  serviceTicketSlice: serviceTicketSlice,
  payementSlice: payementSlice,
  propertiesSlice: propertiesSlice,
  messageSlice: messageListSlice,
  userDetailSlice: userDetailSlice,
  billingSlice: billingSlice,
  transactionHistorySlice: transactionHistorySlice,
  useagaSlice: useageSlice,
  appSlice: appSlice,
  roleSettingSlice: roleSettingSlice,
  legacySlice: legacySlice,
  registerSlice: registerSlice,
  planAddonsSlice: planAddonsSlice,
  communicationSlice: communicationSlice,
  announcementSlice: announcementSlice,
  chatBotSlice: chatBotSlice,
  premiseSlice: premiseSlice,
  documentSlice: documentSlice,
  manageFiberServiceSlice: manageFiberServiceSlice,
  connectionSlice: connectionSlice,
  depositSlice: depositSlice,
  issueCreditSlice: issueCreditSlice,
  enrollmentQueueSlice: enrollmentQueueSlice,
  generateInvoiceSlice: generateInvoiceSlice,
  fiberEnrollmentIssueSlice: fiberEnrollmentIssueSlice,
  signedCommunitiesSlice: signedCommunitiesSlice,
  dailySales: dailySales,
  bulksmxsfupdateSlice: bulksmxsfupdateSlice,
  addPaymentMethodSlice: addPaymentMethodSlice,
});

export default RootReducer;
